<div class="input-container p-col-12 p-grid">
  <search-user class="p-pl-0" [label]="label" (addUser)="addUser.emit($event)"></search-user>
</div>
<div class="p-col-12">
  <user-tile *ngIf="editingContext?.officialAccount?.id" [data]="editingContext.officialAccount">
    <i (click)="removeUser.emit($event)" class="pi pi-times"></i>
  </user-tile>
</div>
